<template>
  <div
    id="main"
    class="wrapper"
  >
    <!-- Sidebar -->
    <div
      id="sidebar"
      v-bind:class="{ active: isActive }"
      class="sticky-top flex-grow-1 sb"
    >
      <sidebar />
    </div>

    <!-- Page Content -->
    <div
      id="content"
      v-bind:class="{ active: isActive }"
    >
      <div
        class="content-header"
        v-bind:class="{ active: isActive }"
      >
        <feedbar
          @navbar-logo-clicked="toggleSidebar"
          @search-clicked="showSearch"
          @new-note-clicked="showNewNote"
        />
      </div>
      <div class="content-body">
        <feed />
        <!-- <feed
          @toggle-sidebar="toggleSidebar"
          @search-button-clicked="showSearch"
          @new-note-clicked="showNewNote"
        /> -->
      </div>
    </div>

    <!-- New Note Modal -->
    <!-- <note-modal /> -->
    <!-- <slide-modal
      v-show="isModalVisible"
      @close="closeModal"
    /> -->

    <note-panel
      v-show="showNotePanel"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import Sidebar from "@/components/Sidebar";
import Feed from "@/components/Feed";
import Feedbar from "@/components/Feedbar";
import NotePanel from "@/components/NotePanel";
import SlideModal from "@/components/SlideModal";

import { userSession } from "../userSession";

export default {
  name: "Home",
  components: {
    Sidebar,
    Feed,
    Feedbar,
    NotePanel,
    SlideModal
  },
  data: function() {
    return {
      isActive: false,
      showNotePanel: false,
      userSession: null,
      user: null
    };
  },
  created() {
    this.userSession = userSession;
  },
  mounted() {
    console.log("Home mounted");
    if (userSession.isUserSignedIn()) {
      console.log("Home - User is signed in");
      this.$router.push("/todos");
    } else if (userSession.isSignInPending()) {
      console.log("Home - User sign in pending");
      userSession.handlePendingSignIn().then(userData => {
        this.$router.push("/todos");
      });
    }
    // console.log("no user - forwarding to login");
    // this.$router.push("/login");

    console.log("finish home mounted routine");
  },
  methods: {
    toggleSidebar() {
      console.log("ok doing the toggling");
      this.isActive = !this.isActive;
    },
    showSearch() {
      console.log("Home: Show Search");
      alert("Clicked Search");
    },
    showNewNote() {
      console.log("Home: Show New Note");
      // this.$bvModal.show("new-note-modal");
      this.showModal();
    },
    showModal() {
      this.showNotePanel = true;
    },
    closeModal() {
      this.showNotePanel = false;
    }
  }
};
</script>

<style scoped>
.wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
  background: #f9f9f9;
}

#sidebar {
  min-width: 250px;
  max-width: 250px;
  transition: all 0.3s;
}

#sidebar.active {
  margin-left: 0;
}

.sb {
  overflow-y: scroll;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
}

/**  STYLE 4 */
.sb::-webkit-scrollbar {
  width: 4px;
}

.sb::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #50557d;
}

.sb::-webkit-scrollbar-thumb {
  background-color: #000000;
  /* border: 2px solid #555555; */
}

#content {
  width: 100%;
  padding: 0px;
  min-height: 100vh;
  transition: all 0.3s;
}

.content-header {
  position: fixed;
  top: 0;
  left: 250px;
  width: calc(100% - 250px);
}

.content-body {
  margin-top: 80px;
}

@media (max-width: 767px) {
  #sidebar {
    min-width: 85vw;
    max-width: 85vw;
    margin-left: -85vw;
  }
  #sidebar.active {
    margin-left: 0;
  }
  #content.active {
    margin-right: -85vw;
    width: 100vw;
  }

  .content-header {
    left: 0px;
    width: 100vw;
  }

  .content-header.active {
    left: 85vw;
    transition: left 0.2s linear;
  }
}
</style>
